import { createTheme } from '@mui/material/styles';
import palette from './palette';
import dimensions from './dimensions';
import components from './components';
import breakpoints from './breakpoints';

const theme = createTheme({
  palette,
  dimensions,
  components,
  breakpoints,
});

export default theme;
